import "./styles/main.css";

import App from "./App";
import React from "react";
import ReactDOM from "react-dom/client";
import { registerCoreUiPlugin } from "./features/core-ui-plugin/registerCoreUiPlugin";
import { registerMeasurementPlugin } from "./features/measurement-plugin/registerMeasurementPlugin";
import { assetCacheService } from "./lib/cache";
import { createPixatwinSdk } from "./sdk";
import { PixatwinSdkProvider } from "./sdk/react";

const pixatwinSdk = createPixatwinSdk();
registerCoreUiPlugin(pixatwinSdk);
registerMeasurementPlugin(pixatwinSdk);

// Initialisation du service de cache des assets 3D
// Ce service permet de stocker les assets 3D en cache pour éviter les re-téléchargements
// La clé de cache est l'ID unique de l'asset (pas le nom de fichier)
assetCacheService.initialize().catch((error) => {
  console.error("[main] Échec de l'initialisation du cache assets 3D:", error);
});

// Note: Cesium est maintenant chargé dynamiquement dans CesiumManager
// pour améliorer le temps de chargement initial

// En développement, React.StrictMode provoque un double-mount des effets.
// Avec Cesium + Draco, ce comportement peut provoquer des pics mémoire (WASM/OOM).
const RootWrapper = import.meta.env.DEV ? React.Fragment : React.StrictMode;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <RootWrapper>
    <PixatwinSdkProvider sdk={pixatwinSdk}>
      <App />
    </PixatwinSdkProvider>
  </RootWrapper>,
);
